import React from 'react';
import { TRANSITION_IMAGE, TRANSITION_LINE } from '../data/resinContent';
export function TransitionImage() {
  return <figure className="w-full bg-black" data-id="element-331" data-mp="1jiv4wu5cr30s">
      <div className="mx-auto max-w-6xl" data-id="element-332" data-mp="1jjxwl4ai19hr">
        <img src={TRANSITION_IMAGE.src} alt={TRANSITION_IMAGE.alt} width={TRANSITION_IMAGE.width} height={TRANSITION_IMAGE.height} loading="lazy" className="h-[30rem] w-full object-cover object-[50%_35%] sm:h-[34rem] lg:h-[36rem]" data-id="element-333" data-mp="1eq23og93ectg" />
      </div>
      <figcaption className="mx-auto max-w-xl px-5 py-7 text-center font-display text-xl italic leading-snug text-ivory-100 sm:text-2xl" data-id="element-334" data-mp="zst5b2ldg8s8">
        {TRANSITION_LINE}
      </figcaption>
    </figure>;
}